import { BillingInformation, SchedulePayment } from './payment.models';

export class PaymentPlan {
  paymentPlanId: number = 0;
  customerId: number;
  providerId: number;
  practiceId: number;
  patientId: number;
  planName: string;
  individualName: string;
  email?: string;
  phone?: string;
  // endDate: string;
  frequency: string;
  frequencyDay: number;
  frequencyWeek: number;
  startDate: string;
  tokenId: number;
  secondaryTokenId: number;
  installment: number;
  totalAmount: number;
  initialAmount: number;
  noOfInstallments: number;
  paymentPlanTemplateId: number;
  templateName: string;
  isDigitalCopySaved?: boolean = false;
  previewOnly: boolean = true;
  createDate?: string;
  customerName?: string;
  isDeleted?: boolean;
  lastPaymentDate?: string;
  nextPaymentDate?: string;
  remainingAmount?: number = 0;
  signedContractPath?: string;
  status?: number = 0;
  statusDate?: string;
  paymentMadeSoFar?: number = 0;
  openPayment: number = 0;
  basedOnDuration: boolean = true;
  isPlanChanged: boolean = false;
  specificRelativeDay: number = 0;
  receivedInstallmentAmount?: number = 0;
  transactionId?: number = 0;
  isPaymentMethodChanged?: boolean = false;
  currentEMIVersion?: number = 0
  patientName?:string='';
  isSendReminder?: boolean = false;
  emailTemplateId?: number;
  smsTemplateId?: number;
  communicationType?: number;
}

export class AdjustPaymentPlan {
  paymentPlanId: number;
  previewOnly: boolean;
  isDigitalCopySaved: boolean;
  adjustmentOption: string;
  amount: number;
  transactionId?: number;


  totalAmount: number;
  isPlanChanged: boolean = false;
  initialAmount: number;
  noOfInstallments: number;
  basedOnDuration: boolean = true;
  individualName: string;
  email: string;
  frequency: string;
  frequencyDay: number;
  frequencyWeek: number;
  specificRelativeDay: number = 1;
  installment: number;
  customerId: number;
  practiceId: number;
  patientId: number;
  pmsPaymentType: number;
  startDate: string;
  tokenId: number;
  patientName?:string='';
  isSendReminder?: boolean = false;
  emailTemplateId?: number;
  smsTemplateId?: number;
  communicationType?: number;
  isReminderSettingChange?: boolean = false;
}

export class EditPreviewPaymentPlan {
  paymentPlan: PaymentPlan = new PaymentPlan();
  paymentPlanEMIWithTokenInfo: PaymentPlanEmiAndToken[] = [];
  paymentPlanAdjustmentsWithTokenInfo: PaymentPlanAdjustmentEmiAndToken[] = [];
  paymentMadeSoFar: number = 0;
}

export class PaymentPlanEmiAndToken {
  paymentPlanEmi: PaymentPlanEmi = new PaymentPlanEmi();
  token: PaymentPlanToken = new PaymentPlanToken();
  transaction: Transaction = new Transaction();
  emiTransactionType: string = '';
}

export class PaymentPlanAdjustmentEmiAndToken {
  paymentPlanAdjustment: PaymentPlanAdjustment = new PaymentPlanAdjustment();
  token: PaymentPlanToken = new PaymentPlanToken();
  transaction: Transaction = new Transaction();
}

export class PaymentPlanAdjustment {
  adjustmentOption: string;
  amount: number;
  createDate: string;
  isDigitalCopySaved: boolean;
  paymentPlanAdjustmentId: number;
  paymentPlanId: number;
  signedContractPath: string;
  transactionId: number;
}

export class UpdatePaymentPlanInitialAmount {
  paymentPlanId: number;
  practiceId: number;
  initialAmount: number;
}

export class Transaction {
  accountNumber: string;
  accountType: any;
  amount: number;
  authorizationCode: any;
  avsResultCode: string;
  bankName: string;
  batchStringId: string;
  billing: any;
  cardType: string;
  checkDate: string;
  checkImagePath: string;
  checkNumber: string;
  createDate: string;
  createdBy: string;
  customerFirstName: string;
  customerId: number;
  customerLastName: string;
  depositeSlipPath: string;
  displayMessage: string;
  emailAddress: string;
  emv: any;
  emvEntryMethod: any;
  id: number;
  individualName: string;
  invoice: any;
  isSuccess: boolean;
  isWriteBackCompleted: boolean;
  lastFour: string;
  merchantId: string;
  note: string;
  patientId: number;
  paymentLink: string;
  paymentPlanEmiId: number;
  paymentPlanId: number;
  phone: string;
  practiceId: number;
  providerId: number;
  refId: number;
  response: string;
  result: any;
  resultCode: any;
  routingNumber: string;
  status: any;
  subject: string;
  systemTerminalId: number;
  terminalId: number;
  tokenId: number;
  totalAmount: number;
  transactionId: number;
  transactionType: number;
  type: any;
  userId: number;
  paymentMode: string;
  transactionCollectionType: number;
  finalPaymentStatus?: number;
  emiTransactionType? : number;
}

export class PaymentPlanToken {
  accountNumber: string;
  accountType: string;
  bankName: string;
  bin: string;
  cardType: string;
  checkName: string;
  code: string;
  created: string;
  customerId: number;
  exchangeId: string;
  expDate: string;
  individualName: string;
  isActive: boolean;
  isDeleted: boolean;
  jwt: string;
  lastFourDigits: string;
  merchantId: string;
  patientId: number;
  payloadType: string;
  practiceId: number;
  preference: number;
  routingNumber: string;
  status: number;
  terminalId: number;
  timesUsed: string;
  tokenId: number;
  tokenStatus: number;
  tokenString: string;
  tokenType: number;
  transactionType: number;
  updated: string;
  transactionId: number;
}

export class PaymentPlanEmi {
  createDate: string;
  customerId: number = 0;
  customerName: string;
  dueDate: string;
  processedDate: string;
  email: string;
  phone: string;
  emiNumber: number = 0;
  installment: number = 0;
  originalInstallment: number = 0;
  subject: string;
  note: string;
  paidDate: string;
  patientId: number = 0;
  transactionId?: number = 0;
  paymentMethod?: string;
  cardType?: string;
  lastFourDigit?: string;
  message?: string;
  paymentPlanEmiId: number = 0;
  paymentPlanId: number = 0;
  practiceId: number = 0;
  providerId: number = 0;
  status: number = 0;
  tokenId: number = 0;
  tokenType: number = 0;
  statusName?: string = '';
}

export class PaymentPlanTemplate {
  paymentPlanTemplateId?: number = 0;
  practiceId: number;
  templateName: string;
  frequency: string;
  duration: number;
  frequencyDay: number;
  frequencyWeek: number;
  requiredIntitialPayment?: boolean = false;
  description: string;
  isActive: boolean;
  createDate?: string;
}

export class PaymentPlanTemplateList {
  paymentPlanTemplates: PaymentPlanTemplate[] = [];
  totalRecords: number = 0;
}

export class PaymentPlanPatientResp {
  paymentPlans: PaymentPlanPatient[] = [];
  totalRecords: number = 0;
}

export class PaymentPlanPatient {
  paymentPlanId: number;
  customerId: number;
  practiceId: number;
  patientId: number;
  // customerKey: string;
  planName: string;
  individualName: string;
  startDate: string;
  endDate: string;
  frequency: string;
  frequencyDay: number;
  paymentAmount: number;
  tokenId: number;
  createDate: string;
  planKey: string;
  customerName: string;
  status: string;
  statusDate: string;
  frequencyWeek: number;
  isDeleted: boolean;
  signedContractPath: string;
  remainingAmount: number;
  totalAmount: number;
  initialAmount: number;
  installment: number;
  secondaryTokenId: number;
  paymentPlanTemplateId: number;
  templateName: string | null;
  nextPaymentDate: string;
  lastPaymentDate: string;
  noOfInstallments: number;
  providerId: number;
  email: string;
  paymentMadeSoFar: number = 0;
  openPayment: number = 0;
  basedOnDuration: boolean = true;
  specificRelativeDay: number = 1;
  isDigitalCopySaved: boolean = false;
  patientname: string;
  receivedInstallmentAmount?: number = 0;
  currentEMIVersion?: number = 0;
  lastEMIStatus?: string;
  noOfRemainingInstallments?: number;
  isSendReminder?: boolean = false;
  emailTemplateId?: number;
  smsTemplateId?: number;
  communicationType?: number;
  totalInstallments?: number;
  pendingInstallments?: number;
}

export class PreviewPaymentPlan {
  paymentPlanId?: number = 0;
  name: string;
  templateId: number = 0;
  templateName: string;
  paymentPlanAmt: number = 0;
  totalAmount?: number = 0;
  todayAmountType?: string = 'AMOUNT';
  todayPaymentAmt?: number = 0;
  remainingPaymentPlanAmt: number = 0;
  remainingPatientPortion: number = 0;
  initialPaymentMethod?: string;
  initialPaymentTokenId?: string;
  initialPaymentTokenType?: number;
  initialPaymentCardType?: string;
  initialPaymentCard?: string;
  initialPaymentBankName?: string;
  initialPaymentIndividualName?: string;
  initialPaymentBillingInformation?: BillingInformation =
    new BillingInformation();
  frequency: string;
  installmentAmount: number = 0;
  duration: number = 0;
  startingDate: string;
  primaryTokenId: number = 0;
  primaryMethod: number;
  primaryCard: string;
  primaryCardType: string;
  secondaryTokenId: number = 0;
  secondaryMethod: number;
  secondaryCard: string;
  secondaryCardType: string;
  terminalId?: string;
  chargeTodayPayment?: SchedulePayment = new SchedulePayment();
  alreadyChargedSchedulePaymentList?: SchedulePayment[] = [];
  paymentPlanAdjustmentEmis?: SchedulePayment[] = [];
  schedulePaymentList: SchedulePayment[] = [];
  storeVirtualCard?: boolean = false;
  accountNumber?: string;
  accountType?: string;
  routingNumber?: string;
  individualName: string;
  paymentPlanIndividualName: string;
  bankName?: string;
  createACHToken?: boolean = true;
  frequencyDay: number = 1;
  frequencyWeek: number = 1;
  Phone?: string;
  Email?: string;
  checkNumber?: string;
  checkAmount?: number;
  checkDate?: string;
  checkImage?: File | null = null;
  depositSlip?: File | null = null;
  subject?: string;
  note?: string;
  openPayment: number = 0;
  basedOnDuration: boolean = true;
  isSpecificDay: boolean = true;
  percentage: number = 0;
  specificRelativeDay: number = 0;
  pmsPaymentType: number = 0;
  pmsPaymentTypeName: string = '';
  isDirect: boolean = false;
  isSendReminder?: boolean = false;
  emailTemplateId?: number;
  smsTemplateId?: number;
  communicationType?: number;
  nextPaymentDate?: string;
}

export class PaymentPlanReportReqCommand {
  searchTerm: string = '';
  sortBy: number = 2;
  pageNumber: number = 1;
  pageSize: number = 15;
  practiceId: number = 0;
  customerId: number = 0;
}

export class PaymentPlanReportResp {
  paymentPlanReport: PaymentPlanReport[] = [];
  totalRecords: number = 0;
}

export class PaymentPlanReport {
  customerId: number = 0;
  patientId: number;
  planName: string;
  practiceId: number;
  totalAmount: number;
  initialAmount: number;
  remainingAmount: number;
  installment: number;
  startDate: string;
  noOfInstallments: number;
}

export class SendPaymentPlanReq {
  patientId: number;
  paymentPlanId: number;
  patientName: string;
  practiceId: number;
  paymentPlan: string;
  toEmail: string;
}

export class GetPaymentPlanEMISchedulesInfoResponse
{
    paymentPlanEMISchedulesInfo: GetPaymentPlanEMISchedulesInfo[]
}
export class GetPaymentPlanEMISchedulesInfo
{
    paymentPlanId: number;
    emiVersion: number;
    createdByName: string;
    createDate: Date;
    strCreateDate?: string;
    status: number; 
}

export class ExportPaymentPlanReportRequest {
  patientId?: number | null;
  isSuccess?: boolean;
  fromTransactionDate?: Date;
  toTransactionDate?: Date;
  moduleReportId?: number;
  practiceId: number;
  sortBy?: number = 2;
  amountDue?: number | null;
  amountOperator?: number | null;
  isOpenInstallments?: boolean;
  patientName?: string | null;
  paymentPlanName?: string | null;
  paymentPlanStatuses?: string[] | null;
  templateName?: string;
  paymentStatus?:number[];
  timeZone?: string;
}